<template>
  <div
    class="pc-banner new"
    v-if="extras.groupKVDisplay.display == 1"
    :style="{ 'background-color': extras.kvBgColor.bgColor }"
  >
    <div
      class="g-banner-div"
      v-if="
        extras.banner &&
        extras.banner.display == 1 &&
        extras.banner.colorOrBg == 'color'
      "
      :style="{
        backgroundColor:
          extras && extras.banner && extras.banner.color
            ? extras.banner.color
            : defaultColor,
      }"
    ></div>

    <img
      class="g-banner-new"
      v-if="
        extras.banner &&
        extras.banner.display == 1 &&
        extras.banner.colorOrBg == 'src'
      "
      :src="extras.banner.src"
    />
    <div class="seminar-info-new pc" :class="extras.BannerText.textAlign">
      <div class="content">
        <div
          class="seminar-title"
          v-if="extras.textSetting.subTitle != 'hide'"
          :style="{
            color:
              extras.textSetting.subTitle == 'custom'
                ? extras.textSetting.fontColor
                : '',
            'font-size':
              extras.textSetting.subTitle == 'custom'
                ? pxOrVw(extras.textSetting.fontSize)
                : '',
            'font-style':
              extras.textSetting.subTitle == 'custom'
                ? extras.textSetting.fontTilt == 'on'
                  ? 'italic'
                  : 'normal'
                : '',
            'font-Weight':
              extras.textSetting.subTitle == 'custom'
                ? extras.textSetting.fontWeight == 'on'
                  ? '900'
                  : ''
                : '',
          }"
        >
          {{ extras.textSetting.text }}
        </div>
        <div
          class="seminar-slogan"
          v-if="extras.textSetting.title != 'hide'"
          :style="{
            color:
              extras.textSetting.title == 'custom'
                ? extras.textSetting.fontColor2
                : '',
            'font-size':
              extras.textSetting.title == 'custom'
                ? pxOrVw(extras.textSetting.fontSize2)
                : '',
            'font-style':
              extras.textSetting.title == 'custom'
                ? extras.textSetting.fontTilt2 == 'on'
                  ? 'italic'
                  : 'normal'
                : '',
            'font-Weight':
              extras.textSetting.title == 'custom'
                ? extras.textSetting.fontWeight2 == 'on'
                  ? '900'
                  : ''
                : '',
          }"
        >
          {{
            extras.textSetting.title == "default"
              ? seminarInfo.title
              : seminarInfo.title
          }}
        </div>
        <div class="semianr-time">
          <div
            class="title"
            v-show="extras.textSetting.timeTitle != 'hide'"
            :style="{
              color:
                extras.textSetting.timeTitle == 'custom'
                  ? extras.textSetting.fontColor3
                  : '',
              'font-size':
                extras.textSetting.timeTitle == 'custom'
                  ? pxOrVw(extras.textSetting.fontSize3)
                  : '',
              'font-style':
                extras.textSetting.timeTitle == 'custom'
                  ? extras.textSetting.fontTilt3 == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'font-Weight':
                extras.textSetting.timeTitle == 'custom'
                  ? extras.textSetting.fontWeight3 == 'on'
                    ? 'bolder'
                    : ''
                  : '',

              background: extras.textSetting.bgColor5 || '',
            }"
          >
            {{
              extras.textSetting.timeTitle == "custom"
                ? extras.textSetting.text3
                : "会议时间"
            }}
          </div>
          <div
            class="_time"
            v-show="extras.textSetting.time != 'hide'"
            :style="{
              color:
                extras.textSetting.time == 'custom'
                  ? extras.textSetting.fontColor4
                  : '',
              'font-size':
                extras.textSetting.time == 'custom'
                  ? pxOrVw(extras.textSetting.fontSize4)
                  : '',
              'font-style':
                extras.textSetting.time == 'custom'
                  ? extras.textSetting.fontTilt4 == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'font-Weight':
                extras.textSetting.time == 'custom'
                  ? extras.textSetting.fontWeight4 == 'on'
                    ? 'bolder'
                    : ''
                  : '',
              background: extras.textSetting.bgColor6 || '',
            }"
          >
            {{ handleTimeStamps(seminarInfo.startTime, seminarInfo.endTime) }}
          </div>
        </div>
      </div>
    </div>

    <div
      class="seminar-status-bar"
      v-show="extras.groupSignUpDisplay.display == 1"
      :style="{
        background:
          extras.barBg.colorOrBg == 'color'
            ? extras.barBg.color
            : 'url(' + extras.barBg.src + ')',
        width: extras && extras.statusBar ? extras.statusBar.browse : '1200px',
      }"
      :class="extras.statusBar.browse"
    >
      <div class="status">
        <div v-if="extras.countdown.display == 1">
          <div
            class="dot"
            v-if="extras.countdown.icon != 'hide'"
            :style="{
              'background-color':
                extras.countdown.icon == 'custom' ? extras.countdown.color : '',
            }"
          ></div>
          <span
            :style="{
              color:
                extras.countdown.text == 'custom'
                  ? extras.countdown.customColor
                  : '',
              'font-size':
                extras.countdown.text == 'custom'
                  ? extras.countdown.fontSize + 'px'
                  : '',
              'font-style':
                extras.countdown.text == 'custom'
                  ? extras.countdown.fontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'font-Weight':
                extras.countdown.text == 'custom'
                  ? extras.countdown.fontWeight == 'on'
                    ? 'bolder'
                    : ''
                  : '',
            }"
            v-if="seminarStatus === 3"
            >进行中</span
          >
          <span
            :style="{
              color:
                extras.countdown.text == 'custom'
                  ? extras.countdown.customColor
                  : '',
              'font-size':
                extras.countdown.text == 'custom'
                  ? extras.countdown.fontSize + 'px'
                  : '',
              'font-style':
                extras.countdown.text == 'custom'
                  ? extras.countdown.fontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'font-Weight':
                extras.countdown.text == 'custom'
                  ? extras.countdown.fontWeight == 'on'
                    ? 'bolder'
                    : ''
                  : '',
            }"
            v-if="seminarStatus === 4"
            >已结束</span
          >
          <span v-if="seminarStatus === 1">
            <span
              :style="{
                color:
                  extras.countdown.text == 'custom'
                    ? extras.countdown.customColor
                    : '',
                'font-size':
                  extras.countdown.text == 'custom'
                    ? extras.countdown.fontSize + 'px'
                    : '',
                'font-style':
                  extras.countdown.text == 'custom'
                    ? extras.countdown.fontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'font-Weight':
                  extras.countdown.text == 'custom'
                    ? extras.countdown.fontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
              }"
              >距离会议开始</span
            >
            <span
              class="seminar-remainder-num"
              :style="{
                color:
                  extras.countdown.time == 'custom'
                    ? extras.countdown.timeCustomColor
                    : '',
                'font-size':
                  extras.countdown.time == 'custom'
                    ? extras.countdown.timeFontSize + 'px'
                    : '',
                'font-style':
                  extras.countdown.time == 'custom'
                    ? extras.countdown.timeFontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'font-Weight':
                  extras.countdown.time == 'custom'
                    ? extras.countdown.timeFontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
              }"
              >{{ remainder.days }}</span
            >
            <span
              :style="{
                color:
                  extras.countdown.text == 'custom'
                    ? extras.countdown.customColor
                    : '',
                'font-size':
                  extras.countdown.text == 'custom'
                    ? extras.countdown.fontSize + 'px'
                    : '',
                'font-style':
                  extras.countdown.text == 'custom'
                    ? extras.countdown.fontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'font-Weight':
                  extras.countdown.text == 'custom'
                    ? extras.countdown.fontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
              }"
              >天</span
            ><span
              class="seminar-remainder-num"
              :style="{
                color:
                  extras.countdown.time == 'custom'
                    ? extras.countdown.timeCustomColor
                    : '',
                'font-size':
                  extras.countdown.time == 'custom'
                    ? extras.countdown.timeFontSize + 'px'
                    : '',
                'font-style':
                  extras.countdown.time == 'custom'
                    ? extras.countdown.timeFontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'font-Weight':
                  extras.countdown.time == 'custom'
                    ? extras.countdown.timeFontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
              }"
              >{{ remainder.hours }}</span
            >
            <span
              :style="{
                color:
                  extras.countdown.text == 'custom'
                    ? extras.countdown.customColor
                    : '',
                'font-size':
                  extras.countdown.text == 'custom'
                    ? extras.countdown.fontSize + 'px'
                    : '',
                'font-style':
                  extras.countdown.text == 'custom'
                    ? extras.countdown.fontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'font-Weight':
                  extras.countdown.text == 'custom'
                    ? extras.countdown.fontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
              }"
              >时</span
            ><span
              class="seminar-remainder-num"
              :style="{
                color:
                  extras.countdown.time == 'custom'
                    ? extras.countdown.timeCustomColor
                    : '',
                'font-size':
                  extras.countdown.time == 'custom'
                    ? extras.countdown.timeFontSize + 'px'
                    : '',
                'font-style':
                  extras.countdown.time == 'custom'
                    ? extras.countdown.timeFontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'font-Weight':
                  extras.countdown.time == 'custom'
                    ? extras.countdown.timeFontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
              }"
              >{{ remainder.minutes }}</span
            ><span
              :style="{
                color:
                  extras.countdown.text == 'custom'
                    ? extras.countdown.customColor
                    : '',
                'font-size':
                  extras.countdown.text == 'custom'
                    ? extras.countdown.fontSize + 'px'
                    : '',
                'font-style':
                  extras.countdown.text == 'custom'
                    ? extras.countdown.fontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'font-Weight':
                  extras.countdown.text == 'custom'
                    ? extras.countdown.fontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
              }"
              >分</span
            >
          </span>
        </div>
      </div>
      <div
        class="seminar-btn"
        v-if="
          !isFrozen && seminarStatus !== 4 && extras.signUpSetting.display == 1
        "
        :style="{
          background:
            extras.signUpSetting.layout == 'custom'
              ? extras.signUpSetting.colorOrBg == 'color'
                ? extras.signUpSetting.color
                : 'url(' + extras.signUpSetting.src + ')'
              : '',
          width:
            extras.signUpSetting.layout == 'custom'
              ? extras.signUpSetting.btnWidth + '%'
              : '',
          color:
            extras.signUpSetting.style == 'custom'
              ? extras.signUpSetting.customColor
              : '',
          'font-size':
            extras.signUpSetting.style == 'custom'
              ? extras.signUpSetting.fontSize + 'px'
              : '',
          'font-style':
            extras.signUpSetting.style == 'custom'
              ? extras.signUpSetting.fontTilt == 'on'
                ? 'italic'
                : 'normal'
              : '',
          'font-Weight':
            extras.signUpSetting.style == 'custom'
              ? extras.signUpSetting.fontWeight == 'on'
                ? 'bolder'
                : ''
              : '',
        }"
      >
        <div
          class="btn"
          :class="isSetting == 1 ? 'cursor-default' : ''"
          v-show="isSetting == 1 && extras.signUpText.display == 1"
        >
          {{ extras.signUpText.model || "立即报名" }}
        </div>

        <div
          class="btn"
          v-show="
            isSetting !== 1 &&
            extras.signUpText.display == 1 &&
            memberInfo.signUpStatus == 0 &&
            !isLogin &&
            seminarInfo.isOpenMember != 0 &&
            signUpUrl
          "
          :style="{
            backgroundColor: extras.signUpBg && extras.signUpBg.color,
          }"
          @click="goto('newLogin')"
        >
          {{ extras.signUpText.model || "立即报名" }}
        </div>
        <div
          v-if="
            isSetting !== 1 &&
            extras.signUpText.display == 1 &&
            memberInfo.signUpStatus == 0 &&
            (isLogin || seminarInfo.isOpenMember == 0) &&
            signUpUrl
          "
          class="btn"
          @click="goto('signUp')"
        >
          {{ extras.signUpText.model || "立即报名" }}
        </div>
        <div
          v-if="
            isSetting !== 1 &&
            memberInfo.signUpStatus == 1 &&
            extras.checkedText.display == 1
          "
          :style="{
            backgroundColor: extras.signUpBg && extras.signUpBg.color,
          }"
          class="btn audit"
          @click="goto('signUp')"
        >
          {{ extras.checkText.model || "审核中..." }}
        </div>
        <div
          v-if="
            isSetting !== 1 &&
            extras.checkedText.display == 1 &&
            (memberInfo.signUpStatus == 2 || memberInfo.signUpStatus == 3)
          "
          :style="{
            backgroundColor: extras.signUpBg && extras.signUpBg.color,
          }"
          class="btn registered"
          @click="goto('signUp')"
        >
          {{ extras.checkedText.model || "报名成功" }}
        </div>
        <div
          v-if="
            isSetting !== 1 &&
            memberInfo.signUpStatus == 4 &&
            extras.rejectText.display == 1
          "
          :style="{
            backgroundColor: extras.signUpBg && extras.signUpBg.color,
          }"
          class="btn refuse"
          @click="goto('signUp')"
        >
          {{ extras.rejectText.model || "拒绝报名" }}
        </div>
        <div v-if="seminarStatus === 2" class="btn registered">会议已结束</div>
      </div>
    </div>
    <div class="frame-outer" v-if="showFrame">
      <div class="sign-frame" :style="{ transform: 'scale(' + scale + ')' }">
        <span class="icontemp stemp-close" @click="close()"></span>
        <iframe frameborder="0" :src="url" ref="frame"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { handleTimeStampToDateTime } from "@/utils/utils";
import { URLS, $subscriber } from "fire-wind-water";
import Api from "../../service/api";
import { goto } from "../../mixins/goto";

export default {
  name: "Banner",
  props: {
    seminarInfo: Object,
    memberInfo: Object,
    signUpStatus: Number,
    loginUrl: String,
    registerUrl: String,
    isFrozen: Boolean,
    extras: Object,
  },
  data: function () {
    return {
      isLogin: false,
      signUpUrl: "",
      url: "",
      scale: 1,
      isSetting: 0,
      remainder: { days: 0, hours: 0, minutes: 0 },
      seminarStatus: 0, //0 未开始 1 已经开始 2 已经结束
      showFrame: false,
      imgUrlObj: {
        pc: {
          kv: require("@/assets/images/pc/banner_new.png"),
        },
      },
      defaultColor: "#ffffff",
    };
  },
  created() {
    if (URLS.getURL("isSetting") == 1) {
      this.isSetting = 1;
    }
  },
  watch: {
    memberInfo() {
      if (URLS.getURL("openSign")) {
        if (
          this.memberInfo.signUpStatus == 0 &&
          (this.isLogin || this.seminarInfo.isOpenMember == 0) &&
          this.signUpUrl
        ) {
          this.goto("signUp");
        }
      }
    },
  },
  mounted() {
    const info = window.$sk.template.get();
    const smarketMember = info.cookie.getSession();
    this.isLogin = !!smarketMember;
    let signUpUrl = this.seminarInfo.signUp;
    const tc = URLS.getURL("tc");
    if (tc) {
      signUpUrl = `${signUpUrl}&tc=${tc}`;
    }
    this.signUpUrl = signUpUrl;
    if (this.seminarInfo && this.seminarInfo.startTime) {
      Api.getServerTime().subscribe((res) => {
        let startTime = this.seminarInfo.startTime * 1000;
        let endTime = this.seminarInfo.endTime * 1000;
        let currentTime = res.content * 1000;
        let diffTime = endTime;
        this.seminarStatus = 3;
        if (currentTime < startTime) {
          this.seminarStatus = 1;
          diffTime = startTime;
        } else if (currentTime > endTime) {
          this.seminarStatus = 4;
          return;
        }
        let dif = moment(diffTime).diff(res.content * 1000, "minutes");
        let days = Math.floor(dif / (24 * 60));
        let hours = Math.floor(dif / 60) - days * 24;
        let minutes = dif % 60;
        this.remainder = {
          days,
          hours,
          minutes,
        };
      });
    } else {
      this.seminarStatus = 0;
    }
  },
  methods: {
    close() {
      $subscriber.emit("reload-userInfo");
      this.showFrame = false;
      document.body.style.setProperty("overflow", "auto");
      this.url = "";
    },
    goto(s) {
      let url = "";
      switch (s) {
        case "newLogin":
          url = goto.newLogin(
            URLS.updateSearchParam("openSign", "1", window.location.href),
            true
          );
          window.$sk.goto(url);
          break;
        case "login":
          // goto.loginToSignUp();
          url = goto.login(
            URLS.updateSearchParam("openSign", "1", window.location.href),
            true
          );
          window.$sk.goto(url);
          break;
        case "signUp":
          this.url = goto.signUp(true);
          // this.url = 'http://uat-local.smarket.net.cn:8081/?customFormId=2308101668095181&instanceId=716348&linkId=364662&configId=1992808&preview=1#/pcNew_index';
          this.showFrame = true;
          document.body.style.setProperty("overflow", "hidden");
          setTimeout(() => {
            const height = window.innerHeight;
            const height2 = 837;
            if (height < height2) {
              this.scale = (height / height2) * 0.97;
            }
          }, 0);

          break;
      }
    },
    handleTimeStamps: (startTimeStamp, endTimeStamp) => {
      let startTimeYear = handleTimeStampToDateTime(
        startTimeStamp * 1000,
        "YYYY"
      );
      let endTimeYear = handleTimeStampToDateTime(endTimeStamp * 1000, "YYYY");
      let startDate = handleTimeStampToDateTime(
        startTimeStamp * 1000,
        "YYYY-MM-DD"
      );
      let endDate = handleTimeStampToDateTime(
        endTimeStamp * 1000,
        "YYYY-MM-DD"
      );
      if (startDate == endDate) {
        return (
          handleTimeStampToDateTime(
            startTimeStamp * 1000,
            "YYYY年MM月DD日 HH:mm"
          ) +
          "~" +
          handleTimeStampToDateTime(endTimeStamp * 1000, "HH:mm")
        );
      } else if (startTimeYear == endTimeYear) {
        return (
          handleTimeStampToDateTime(startTimeStamp * 1000, "YYYY年MM月DD日") +
          "~" +
          handleTimeStampToDateTime(endTimeStamp * 1000, "MM月DD日")
        );
      } else {
        return (
          handleTimeStampToDateTime(startTimeStamp * 1000, "YYYY年MM月DD日") +
          "~" +
          handleTimeStampToDateTime(endTimeStamp * 1000, "YYYY年MM月DD日")
        );
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
